import { render, staticRenderFns } from "./EditTeachers.vue?vue&type=template&id=5d1c0695&"
import script from "./EditTeachers.vue?vue&type=script&lang=js&"
export * from "./EditTeachers.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports